import React from 'react';
import { HomeworkItem } from '@homework-app/shared';
import HomeworkItemComponent from './HomeworkItemComponent';

interface PeriodBoxProps {
  period: number;
  subject: string;
  periodName: string;
  homeworkItems: HomeworkItem[];
  onAddHomework: (period: number, text: string) => void;
  onUpdateHomework: (id: string, text: string, completed: boolean) => void;
  onDeleteHomework: (id: string) => void;
  onPhotoUpload: (homeworkId: string, file: File) => void;
  onPhotoClick: (photoSrc: string) => void;
}

const PeriodBox: React.FC<PeriodBoxProps> = ({
  period,
  subject,
  periodName,
  homeworkItems,
  onAddHomework,
  onUpdateHomework,
  onDeleteHomework,
  onPhotoUpload,
  onPhotoClick
}) => {
  const incompleteTasks = homeworkItems.filter(item => !item.completed).length;

  // One tap to add homework with subject pre-filled
  const handleAddHomework = () => {
    onAddHomework(period, subject);
  };

  return (
    <div className="period-box">
      <div
        className={`period-header period-${period} period-header--clickable`}
        onClick={handleAddHomework}
        title={`Click to add ${subject} homework`}
      >
        <span>{periodName}</span>
        <span className="task-count">{incompleteTasks > 0 ? `${incompleteTasks} left` : '✓'}</span>
      </div>
      <div className="period-content">
        {homeworkItems.map(item => (
          <HomeworkItemComponent
            key={item.id}
            item={item}
            onUpdateHomework={onUpdateHomework}
            onDeleteHomework={onDeleteHomework}
            onPhotoUpload={onPhotoUpload}
            onPhotoClick={onPhotoClick}
          />
        ))}
        {homeworkItems.length === 0 && (
          <div className="no-homework-hint" onClick={handleAddHomework}>
            Tap to add homework
          </div>
        )}
      </div>
    </div>
  );
};

export default PeriodBox;
